<sd-tab-bar-item-legacy
  *ngIf="(deviceService.isMobileSmDown$ | async) === false"
  icon="MENU"
  [isActive]="isActive$ | async"
  (click)="onToggle()"
></sd-tab-bar-item-legacy>
